import script from "./ExportPDF.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExportPDF.vue?vue&type=script&lang=ts&setup=true"

import "./ExportPDF.vue?vue&type=style&index=0&id=1668f898&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1668f898"]])

export default __exports__